import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/backoffice-actions')({
  beforeLoad: () => getTitleContextSlice('Backoffice Actions'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
